import React from "react";
import { Switch } from "@headlessui/react";

export default function HideSold({ hideRemoved, setHideRemoved }) {
  return (
    <div className="">
      <div className="font-bold mb-1">Göm sålda och borttagna</div>
      <Switch
        checked={hideRemoved}
        onChange={setHideRemoved}
        className={`${
          hideRemoved ? "bg-blue-600" : "bg-gray-200"
        } relative inline-flex h-6 w-11 items-center rounded-full`}
      >
        <span className="sr-only">Enable notifications</span>
        <span
          className={`${
            hideRemoved ? "translate-x-6" : "translate-x-1"
          } inline-block h-4 w-4 transform rounded-full bg-white`}
        />
      </Switch>
    </div>
  );
}
